import React from 'react'
import Text from 'core/elements/Text'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

interface Info {
  label: string
  value?: string | number
  customValue?: React.ReactNode
}

interface Props {
  data: Info[]
}

const useStyles = makeStyles<Theme, Partial<Props>>((theme: Theme) => ({
  overviewCellsContainer: {
    marginTop: 24,
    marginBottom: 68,
    borderTop: `16px solid ${theme.components.table.hoverBackground}`,
    borderBottom: `16px solid ${theme.components.table.hoverBackground}`,
    background: theme.components.table.border,
    display: 'grid',
    gap: '1px',
    gridTemplateColumns: ({ data }) =>
      data?.length
        ? Array(data.length)
            .fill('1fr')
            .join(' ')
        : '1fr 1fr 1fr 1fr',
  },
  overviewCell: {
    background: theme.components.table.hoverBackground,
    paddingLeft: 24,
  },
}))

export default function InfoBlocks({ data }: Props) {
  const classes = useStyles({ data })

  return (
    <div className={classes.overviewCellsContainer}>
      {data.map((info) => (
        <div className={classes.overviewCell} key={info.label}>
          <Text variant="body2">{info.label}</Text>
          {info?.customValue ? info.customValue : <Text variant="caption1">{info.value}</Text>}
        </div>
      ))}
    </div>
  )
}
